import $ from '../$';
import { JQ } from '../JQ';
import './slice';
$.fn.eq = function (index) {
    const ret = index === -1 ? this.slice(index) : this.slice(index, +index + 1);
    return new JQ(ret);
};
